import { Search } from "lucide-react";
import { useLanguage } from "@/lib/LanguageContext";

const Header = () => {
  const { lang, toggleLanguage, t } = useLanguage();

  return (
    <header className="relative z-10 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-yellow-400 to-amber-500 flex items-center justify-center">
            <Search className="w-5 h-5 text-black" />
          </div>
          <span className="font-bold text-xl tracking-tight text-white" style={{ fontFamily: 'Inter, sans-serif' }}>
            {t("header.brand")}
          </span>
        </div>

        {/* Language toggle */}
        <button
          onClick={toggleLanguage}
          className="flex items-center gap-1 text-sm font-medium text-white/60 hover:text-white transition-colors"
          aria-label="Toggle language"
        >
          <span className={lang === "en" ? "text-yellow-400 font-bold" : ""}>EN</span>
          <span className="text-white/30">|</span>
          <span className={lang === "de" ? "text-yellow-400 font-bold" : ""}>DE</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
